<script setup>
// Confirmação de exclusão dentro do sistema.
//
// Usa `components/Modal.vue` de propósito, e não o `components-next/dialog`:
// esta tela vive dentro do modal de equipe (um Teleport próprio), e o Modal é
// o mesmo componente que os formulários de material/evento/curso já usam aqui
// com sucesso.
import Modal from 'dashboard/components/Modal.vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  title: { type: String, required: true },
  description: { type: String, default: '' },
  confirmLabel: { type: String, default: 'Excluir' },
  isProcessing: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'confirm']);
</script>

<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<template>
  <Modal show :on-close="() => emit('close')" size="small">
    <div class="flex w-full flex-col gap-4 p-6">
      <h3 class="m-0 text-body-large font-medium text-n-slate-12">
        {{ title }}
      </h3>
      <p v-if="description" class="m-0 text-body-small text-n-slate-11">
        {{ description }}
      </p>
      <div class="flex justify-end gap-2 pt-2">
        <Button label="Cancelar" variant="ghost" @click="emit('close')" />
        <Button
          :label="confirmLabel"
          color="ruby"
          :is-loading="isProcessing"
          @click="emit('confirm')"
        />
      </div>
    </div>
  </Modal>
</template>
